
    import _Handlebars from 'handlebars/runtime';

    var Handlebars = _Handlebars.default;
    import "/home/canvas/public_html/ui/shared/message-students-dialog/jst/_messageStudentsWhoRecipientList.handlebars";
import "@canvas/i18n";
import "@canvas/handlebars-helpers/index.js";

    var template = Handlebars.template, templates = Handlebars.templates = Handlebars.templates || {};
    var name = '/home/canvas/public-html/ui/shared/message-students-dialog/jst/messageStudentsDialog';
    templates[name] = template(function (Handlebars,depth0,helpers,partials,data) {
  this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Handlebars.helpers); partials = this.merge(partials, Handlebars.partials); data = data || {};
  var buffer = "", stack1, helper, options, functionType="function", escapeExpression=this.escapeExpression, self=this, helperMissing=helpers.helperMissing;

function program1(depth0,data) {
  
  var buffer = "", stack1;
  buffer += "\n      "
    + escapeExpression(((stack1 = ((stack1 = ((stack1 = (depth0 && depth0.recipientGroups)),stack1 == null || stack1 === false ? stack1 : stack1[0])),stack1 == null || stack1 === false ? stack1 : stack1.name)),typeof stack1 === functionType ? stack1.apply(depth0) : stack1))
    + "\n      <input type=\"hidden\" name=\"recipientGroupName\" value=\""
    + escapeExpression(((stack1 = ((stack1 = ((stack1 = (depth0 && depth0.recipientGroups)),stack1 == null || stack1 === false ? stack1 : stack1[0])),stack1 == null || stack1 === false ? stack1 : stack1.name)),typeof stack1 === functionType ? stack1.apply(depth0) : stack1))
    + "\" />\n    ";
  return buffer;
  }

function program3(depth0,data) {
  
  var buffer = "", stack1;
  buffer += "\n      <select name=\"recipientGroupName\" id=\"message-recipients-group\">\n        ";
  stack1 = helpers.each.call(depth0, (depth0 && depth0.recipientGroups), {hash:{},inverse:self.noop,fn:self.program(4, program4, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n      </select>\n    ";
  return buffer;
  }
function program4(depth0,data) {
  
  var buffer = "", stack1, helper;
  buffer += "\n          <option value=\"";
  if (helper = helpers.name) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.name); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "\">";
  if (helper = helpers.name) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.name); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "</option>\n        ";
  return buffer;
  }

  buffer += "<div class=\"message-students-dialog form-dialog-content\">\n  <div class=\"message-recipients-group-container\">\n    <label for=\"message-recipients-group\">\n     "
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (true),
    'i18n_scope': ("message_students_dialog")
  },data:data},helper ? helper.call(depth0, "recipients_a69b5e55", "Recipients:", options) : helperMissing.call(depth0, "t", "recipients_a69b5e55", "Recipients:", options)))
    + "\n    </label>\n\n    ";
  stack1 = (helper = helpers.ifEqual || (depth0 && depth0.ifEqual),options={hash:{},inverse:self.program(3, program3, data),fn:self.program(1, program1, data),data:data},helper ? helper.call(depth0, ((stack1 = (depth0 && depth0.recipientGroups)),stack1 == null || stack1 === false ? stack1 : stack1.length), 1, options) : helperMissing.call(depth0, "ifEqual", ((stack1 = (depth0 && depth0.recipientGroups)),stack1 == null || stack1 === false ? stack1 : stack1.length), 1, options));
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n  </div>\n\n  <div id=\"message-recipients\">\n    ";
  stack1 = self.invokePartial(partials['ui/shared/message-students-dialog/jst/_messageStudentsWhoRecipientList.handlebars'], 'ui/shared/message-students-dialog/jst/_messageStudentsWhoRecipientList.handlebars', depth0, helpers, partials, data);
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n  </div>\n\n  <textarea name=body></textarea>\n\n</div>\n<div class=\"form-controls\">\n  <button class=\"btn dialog_closer btn-secondary\" type=\"button\"\n    data-text-while-loading='"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (true),
    'i18n_scope': ("message_students_dialog")
  },data:data},helper ? helper.call(depth0, "sending_bf324366", "Sending...", options) : helperMissing.call(depth0, "t", "sending_bf324366", "Sending...", options)))
    + "'>\n    "
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (true),
    'i18n_scope': ("message_students_dialog")
  },data:data},helper ? helper.call(depth0, "cancel_caeb1e68", "Cancel", options) : helperMissing.call(depth0, "t", "cancel_caeb1e68", "Cancel", options)))
    + "\n  </button>\n  <button class=\"btn btn-primary\"\n    data-text-while-loading='"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (true),
    'i18n_scope': ("message_students_dialog")
  },data:data},helper ? helper.call(depth0, "sending_bf324366", "Sending...", options) : helperMissing.call(depth0, "t", "sending_bf324366", "Sending...", options)))
    + "'\n    data-text-when-loaded='"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (true),
    'i18n_scope': ("message_students_dialog")
  },data:data},helper ? helper.call(depth0, "sent_f4ee89ec", "Sent!", options) : helperMissing.call(depth0, "t", "sent_f4ee89ec", "Sent!", options)))
    + "'>\n    "
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (true),
    'i18n_scope': ("message_students_dialog")
  },data:data},helper ? helper.call(depth0, "send_message_6ccc90e8", "Send Message", options) : helperMissing.call(depth0, "t", "send_message_6ccc90e8", "Send Message", options)))
    + "\n  </button>\n\n</div>\n";
  return buffer;
  });
    ;
    
    import brandableCss from '@canvas/brandable-css';

    brandableCss.loadStylesheetForJST({
      id: 'e2',
      bundle: 'jst/messageStudentsDialog'
    });
  ;
    export default templates[name];
  